import React, { useState, useEffect } from "react";
import { instance } from "../../axios";
import "bootstrap/dist/css/bootstrap.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BgLoader, UiButton, PageError } from "../../ui";
import { LoginUser, setStorage } from "../../helper";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const SwitchAccount = ({ ...props }) => {
  let navigat = useNavigate();
  const [loader, showLoader] = useState(false);
  const schema = yup.object().shape({



  });

  const [state, setState] = useState({});
  var doLogin = (e) => {
    showLoader(true)
    var form = document.querySelector("#accform");
    var data = new FormData(form);

    instance({
      method: "post",
      url: "/cust_switch",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        showLoader(false)
        if (response.data.status == 'success') {
          setStorage("token", response.data.token);
          navigat("/", { replace: true });
        }
        if (response.data.status == 'error') {
          toast(response.data.msg, { type: "error" });
        }

      })
      .catch(function (response) { });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    resetField,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    doLogin();
    //reset();
  };


  const fetchData = () => {
    instance
      .get("/cust_switch_account")
      .then(function (response) {
        setState({ ...state, ...response.data })
      })
      .catch(function (error) { })
      .then(function () { });
  }



  useEffect(() => {
    fetchData()

  }, []);







  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }







  return (
    <div className="container h-100">
      <Helmet>
        <title>Select Account</title>
        {state.company && state.company.logo  &&  <link rel="icon" type="image/x-icon" href={state.company.logo}></link>}
      </Helmet>
      {loader && (
        <div className="overlay">
          <div className="overlay__inner">
            <div className="overlay__content"><span className="spinner"></span></div>
          </div>
        </div>
      )}
      {state.items ?
        <div className="row d-flex justify-content-center align-items-center h-100 pt-5">

          <div className="col-12 col-md-8 col-lg-6 col-xl-5 px-4">

            <button className="w-100 btn mb-4 btn-light" onClick={() => navigat('/')}  ><MdOutlineKeyboardArrowLeft /> Go back</button>
            <h3 className="mb-2">Select Account</h3>
            <p>Please select the account which you want to login</p>

            <form id="accform" onSubmit={handleSubmit(onSubmitHandler)}>
              <div className="card card-default mb-4 overflow-auto" style={{ maxHeight: '400px' }}>
                <div className="card-body">
                  {state.items.map((val, i) => (
                    <div className="form-check blist" key={i}>
                      <input className="form-check-input" type="radio" name="account" id={`acc${i}`} defaultChecked={val.selected} value={val.id} {...register("account")} />
                      <label className="form-check-label" htmlFor={`acc${i}`}>
                        {val.name}
                      </label>
                    </div>

                  ))}
                </div>
              </div>
              <UiButton className="w-100 btn btn-lg btn-primary" title='Select' />
            </form>

          </div>
        </div>
        : <BgLoader />}
    </div>
  );
};

export default SwitchAccount;
